var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\xB6\x88\xE6\x81\xAF 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x9B\xBE\xE5\xB1\x82 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x9B\xBE\xE5\xB1\x82 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5185 6.37038C14.5115 5.76025 14.3844 5.15748 14.1445 4.59647C13.9046 4.03546 13.5565 3.52721 13.1201 3.10074C12.6837 2.67427 12.1676 2.33794 11.6012 2.11094C11.0349 1.88395 10.4293 1.77074 9.81922 1.77778H6.18071C5.57058 1.77074 4.96505 1.88395 4.39868 2.11094C3.83231 2.33794 3.3162 2.67427 2.87983 3.10074C2.44345 3.52721 2.09536 4.03546 1.85542 4.59647C1.61549 5.15748 1.48841 5.76025 1.48145 6.37038C1.48841 6.9805 1.61549 7.58328 1.85542 8.14428C2.09536 8.70529 2.44345 9.21354 2.87983 9.64001C3.3162 10.0665 3.83231 10.4028 4.39868 10.6298C4.96505 10.8568 5.57058 10.97 6.18071 10.963H7.28293V13.5141L12.56 9.95852C13.1159 9.5949 13.5814 9.10901 13.9209 8.53796C14.2603 7.96692 14.4647 7.32584 14.5185 6.66371C14.5185 6.56692 14.5185 6.46815 14.5185 6.36741V6.37038Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.f1e0e60410366503c78b204d6ce683fc.svg";
export { ForwardRef as ReactComponent };